import ModalOpener from '../../components/modal/modal-opener'

class PasswordModalOpener extends ModalOpener {
  connectedCallback(): void {
    super.connectedCallback()

    this.focus()
  }
}

export default PasswordModalOpener
